import { useField } from 'formik';
import { FormField, TextArea, Tooltip } from '@neshane/blueberry';

/**
 * Formik-wrapped Textarea Component
 */
export const FormikTextarea = ({
    label,
    helpText,
    rows = 4,
    className = '',
    required,
    id,
    disabled,
    readOnly,
    placeholder,
    tooltip,
    infoTipContent,
    tooltipPlacement = 'top',
    ...props
}) => {
    const [field, meta] = useField(props);
    const hasError = meta.touched && meta.error;
    const inputId = id || props.name;

    const inputElement = (
        <TextArea
            id={inputId}
            rows={rows}
            placeholder={placeholder}
            isDisabled={disabled}
            isReadOnly={readOnly}
            isInvalid={hasError}
            {...field}
        />
    );

    return (
        <FormField
            className={className}
            label={required ? `${label} *` : label}
            htmlFor={inputId}
            description={helpText && !hasError ? helpText : undefined}
            alertMessage={hasError ? meta.error : undefined}
            infoTipContent={infoTipContent}
        >
            {tooltip ? (
                <Tooltip content={tooltip} placement={tooltipPlacement}>
                    <div style={{ width: '100%' }}>{inputElement}</div>
                </Tooltip>
            ) : (
                inputElement
            )}
        </FormField>
    );
};

export default FormikTextarea;
